import React from 'react';
import BudgetChannelsCard from '../components/BudgetChannelsCard';

export default function BudgetOverview() {
  return (
    <div className="min-h-screen bg-[#f6f8ff]/70">
      <div className="max-w-5xl mx-auto px-6 py-8">
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold ring-1 ring-blue-200 mb-3">
            Bütçe · Genel Bakış
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Bütçe Genel Bakış</h1>
          <p className="mt-2 text-gray-600 text-sm max-w-3xl leading-relaxed">
            Bu brand'e bağlı tüm reklam platformları için aylık bütçe kullanımı.
            Hedefler <code className="px-1 mx-1 rounded bg-gray-100 text-[11px]">monthly_targets_v2</code>
            tablosunda saklanır; ay içi harcama platform daily-summary tablolarından canlı hesaplanır.
          </p>
        </div>

        <BudgetChannelsCard showHeader showTotalSummary />
      </div>
    </div>
  );
}
